import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'gender'
})
export class GenderPipe implements PipeTransform {
  transform(gender: string): string {
    if (gender == undefined || gender == null || gender === '') {
      return '--';
    }

    const str = gender.toLowerCase();
    const male = ['male', 'm', '1'];
    const female = ['female', 'f', '2'];
    const undisclosed = ['undisclosed', 'u', '3'];
    let displayGender = '';
    if (male.includes(str)) {
      displayGender = 'Male';
    } else if (female.includes(str)) {
      displayGender = 'Female';
    } else if (undisclosed.includes(str)) {
      displayGender = 'Undisclosed';
    } else {
      displayGender = '--';
    }

    return displayGender;
  }
}
